import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserData } from '../models/user-data.model';
import { DwUserResponse } from '../models/dw-user-response.model';
import { UserInformationUpdate } from '../models/user-information-update.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SmsService {
  userStatus = '';
  userCode = 0;
  constructor(private http: HttpClient) {}

  private dwUserUrl = `${environment.dwApiUrl}/dwuser/opt/`;
  private getUserCodeUrl = `${environment.dwApiUrl}/dwuser/`;

  getUserData(token: string, email: string): Observable<UserData> {
    let url = `${this.dwUserUrl}${email}`;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<UserData>(url, {
      headers: headers,
    });
  }

  setUserStatus(status: string) {
    this.userStatus = status;
  }

  getUserStatusOnService() {
    return this.userStatus;
  }

  setUserCode(code: number) {
    this.userCode = code;
  }

  getUserCodeOnService() {
    return this.userCode;
  }

  getUserCode(token: string, email: string): Observable<DwUserResponse> {
    let url = `${this.getUserCodeUrl}${email}`;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<DwUserResponse>(url, {
      headers: headers,
    });
  }

  modifyUserSelection(
    token: string,
    requestBody: UserInformationUpdate
  ): Observable<UserInformationUpdate> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const body = requestBody;
    return this.http.post<UserInformationUpdate>(this.dwUserUrl, body, {
      headers: headers,
    });
  }
}
